import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import type { ApiProdutoGetParams } from './apiProdutoGet';
import { ProdutoTipo } from '../types/enum';

const ProdutoTotaisPorTipoSchema = z.object({
    descricao: z.string(),
    quantidade_total: z.number(),
    tipo: z.enum(ProdutoTipo).nullable(),
});

const schema = registrosSchema(ProdutoTotaisPorTipoSchema);

function apiProdutoTotaisPorTipo({
    idpk,
    params,
}: {
    idpk?: number;
    params?: ApiProdutoGetParams;
}) {
    return fetchApi({
        endpoint: 'Produto/TotaisPorTipo',
        idpk,
        method: 'get',
        params,
        schema,
    });
}

export const API_PRODUTO_TOTAIS_POR_TIPO_KEY = 'apiProdutoTotaisPorTipo';

export function apiProdutoTotaisPorTipoQueryOptions({
    idpk,
    params,
}: {
    idpk?: number;
    params?: ApiProdutoGetParams;
}) {
    return queryOptions({
        queryFn: () => apiProdutoTotaisPorTipo({ idpk, params }),
        queryKey: [API_PRODUTO_TOTAIS_POR_TIPO_KEY, idpk, params],
    });
}
